import { CheckOutlined, CloseOutlined } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { ManagerCreationRole } from "./usersAPI";

type RoleItem = {
  index: string;
  isAllowed: boolean;
};

type RoleDetails = {
  icon: JSX.Element;
  iconColor: string;
  text: string;
  textColor: string;
};
export const statusColor = {
  ACTIVE: {
    backgroundColor: colors["colors/system/success/success_ultraLight"],
    textColor: colors["colors/system/success/success_normal"],
  },
  PENDING: {
    backgroundColor: colors["colors/system/informative/informative_ultraLight"],
    textColor: colors["colors/system/informative/informative_normal"],
  },
  DEACTIVATED: {
    backgroundColor: colors["colors/surfaces/background/background_level2"],
    textColor: colors["colors/text/black"],
  },
  EXPIRED: {
    backgroundColor: colors["colors/surfaces/background/background_level2"],
    textColor: colors["colors/text/black"],
  },
  CANCELED: {
    backgroundColor: colors["colors/system/error/error_ultraLight"],
    textColor: colors["colors/system/error/error_normal"],
  },
};

const generateRoleDetails = (
  role: ManagerCreationRole,
  items: RoleItem[],
): RoleDetails[] =>
  items.map(({ index, isAllowed }) => ({
    icon: isAllowed ? <CheckOutlined /> : <CloseOutlined />,
    iconColor: isAllowed
      ? colors["colors/system/success/success_normal"]
      : colors["colors/text/lightGrey"],
    textColor: isAllowed
      ? colors["colors/text/black"]
      : colors["colors/text/lightGrey"],
    text: `users.modal.role.informations.${role}.${index}`,
  }));

export const roleDetails: Record<ManagerCreationRole, RoleDetails[]> = {
  ADMIN: generateRoleDetails("ADMIN", [
    { index: "one", isAllowed: true },
    { index: "two", isAllowed: true },
    { index: "three", isAllowed: false },
  ]),
  USER: generateRoleDetails("USER", [
    { index: "one", isAllowed: true },
    { index: "two", isAllowed: false },
    { index: "three", isAllowed: false },
    { index: "four", isAllowed: false },
  ]),
  DEPARTMENT_USER: generateRoleDetails("DEPARTMENT_USER", [
    { index: "one", isAllowed: true },
    { index: "two", isAllowed: false },
    { index: "three", isAllowed: false },
    { index: "four", isAllowed: false },
  ]),
};
